export default __webpack_public_path__ + "static/media/EM1880.34I-42613_-25694_0.13f54c23.jpg";